<template>
<!--  <div :style="{'height': mainHeight, 'overflow': 'hidden'}">-->
  <div style="padding: 0px" :style="{'minHeight': mainHeight}">
    <Home v-if="pagePath === '/home'"></Home>
    <Register v-if="pagePath === '/register'"></Register>
    <LostPassword v-if="pagePath === '/lostPassword'"></LostPassword>
    <ModifyPassword v-if="pagePath === '/modifyPassword'"></ModifyPassword>
    <Shine v-if="pagePath === '/shine'"></Shine>
    <Epiclock v-if="pagePath === '/epi-clock'"></Epiclock>
    <Wind v-if="pagePath === '/wind'"></Wind>
    <About v-if="pagePath === '/about'"></About>
    <Feedback v-if="pagePath === '/feedback'"></Feedback>
  </div>
</template>

<script>
import Home from './home'
import Register from './register'
import LostPassword from './lostPassword'
import ModifyPassword from './modifyPassword'
import Shine from './shine'
import Epiclock from './epiclock'
import Wind from './wind'
import About from './about'
import Feedback from './feedback'

export default {
  name: 'tabMains',
  data () {
    return {
      mainHeight: 0
    }
  },
  computed: {
    pagePath () {
      return this.$route.path
    }
  },
  watch: {
    $route: function (n) {
      console.log(n)
    }
  },
  mounted () {
    this.$nextTick(() => {
      var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

      var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

      this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')

      window.addEventListener('resize', function () {
        var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

        var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

        this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')
      }.bind(this))
    })
  },
  components: {
    Home,
    Register,
    LostPassword,
    ModifyPassword,
    Shine,
    Epiclock,
    Wind,
    About,
    Feedback
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tabMains.vue